import {
  useEffect, useMemo, useRef, useState
} from "react";
import { useParticipant } from "@videosdk.live/react-sdk";
import { App, Avatar, Flex } from "antd";
import ReactPlayer from "react-player";
import DisplayName from "./displayName";
import classes from "./participantView.module.css";
import useVideoStore from "../../hooks/useVideoStore";

const ParticipantView = ({ participantId }: { participantId: string }) => {
  const {
    displayName,
    webcamStream,
    micStream,
    webcamOn,
    micOn,
    isLocal,
    mode,
  } = useParticipant(participantId);

  const { selectedSpeaker } = useVideoStore();
  const micRef = useRef<HTMLAudioElement | null>(null);
  const [mouseOver, setMouseOver] = useState(false);
  const { message } = App.useApp();

  useEffect(() => {
    if (micRef.current) {
      if (micOn && micStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(micStream.track);
        micRef.current.srcObject = mediaStream;
        try {
          // @ts-ignore
          micRef.current.setSinkId(selectedSpeaker.id);
        } catch (err) {
          // message.error(`Setting speaker device failed, ${err}`);
        }
        micRef.current
          .play()
          .catch((error) => {
            message.error(`micRef.current.play() failed, ${error}`);
          });
      } else {
        micRef.current.srcObject = null;
      }
    }
  }, [micStream, micOn, selectedSpeaker]);

  const webcamMediaStream = useMemo(() => {
    if (webcamOn && webcamStream) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(webcamStream.track);
      return mediaStream;
    }

    return "";
  }, [webcamStream, webcamOn]);

  return mode === "CONFERENCE" ? (
    <div
      onMouseEnter={() => {
        setMouseOver(true);
      }}
      onMouseLeave={() => {
        setMouseOver(false);
      }}
      className={classes.root}
    >
      <audio ref={micRef} autoPlay muted={isLocal}>
        <track kind="captions"/>
      </audio>
      {webcamOn ? (
        <ReactPlayer
          playsinline
          pip={false}
          light={false}
          controls={false}
          muted
          playing
          url={webcamMediaStream}
          height="100%"
          width="100%"
          onError={(err) => {
            message.error(`participant video error, ${err}`);
          }}
        />
      ) : (
        <Flex justify="center" align="center" style={{ width: "100%", height: "100%" }}>
          <Avatar size={60}>{String(displayName).charAt(0).toUpperCase()}</Avatar>
        </Flex>
      )}
      <DisplayName
        participantId={participantId}
        displayName={displayName}
        isLocal={isLocal}
        mouseOver={mouseOver}
      />
    </div>
  ) : null;
};

export default ParticipantView;
